module.exports = __webpack_public_path__ + "static/media/more.46f529db.svg";